module.exports = __webpack_public_path__ + "img/discover.62706277.png";